// https://vuex.vuejs.org/en/actions.html

import NewApiService from "@/utils/new.api.service";

export default {
  list({commit}, { pagination,filters}) {

    const { sortBy, sortDesc, page, itemsPerPage } = pagination ?? [null, null, null, null];

    const sort = [];
    if(sortBy.length){
      for (let idx = 0; idx < sortBy.length; idx++) {
        let s = sortDesc[idx]?'-':'';
        s += sortBy[idx]
        sort.push(s);
      }
    }

    commit("setLoading", true);
    return new Promise((resolve,reject) => {
      NewApiService.get("payouts",{
        page: page,
        sort: sort.join(","),
        rowsPerPage: itemsPerPage,
        filter: filters
      })
        .then(({ data }) => {
          commit("setPayouts", data);
          resolve(data);
        })
        .catch(({ response }) => {
            reject(response.data.errors);
        })
        .finally(() => {
          commit("setLoading", false);
        })
    });
  },
  export({commit}, {filters})
  {
    commit("setLoading", true);
    return new Promise((resolve) => {
        NewApiService.get(
            "payouts/export",
            {
                filter: filters
            },
            { responseType: "blob" }
        )
            .then(({ data }) => {
                commit("setLoading", false);
                resolve(data);
            })
            .catch(({ response }) => {
                commit("set_error", response.data.errors);
            });
    });
  }
}